import script from "./LoginPromptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPromptModal.vue?vue&type=script&setup=true&lang=js"

import "./LoginPromptModal.vue?vue&type=style&index=0&id=25234902&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25234902"]])

export default __exports__